module.exports = __webpack_public_path__ + "static/media/harshit.0b0ec0be.jpg";